export enum AlertImportanceEnum {
  Warning = 'Warning',
  Info = 'Info',
  Danger = 'Danger',
  Secondary = 'Secondary',
  Success = 'Success'
}
